<template>
  <b-row>
    <b-col>
      <h1>Welcome</h1>
      <p>
        Thanks for signing up!
      </p>
      <b-form-group
        label="Pick a username"
        description="This name can not be changed later. It will be used in URLs linking to your decks."
        :state="isUsernameValid"
        :invalidFeedback="invalidUsername"
      >
        <b-form-input
          v-model="username"
          placeholder=""
          :state="isUsernameValid"
          trim
          debounce="500"
        />
      </b-form-group>
      <b-form-group
        label="Pick a display name"
        description="This can be changed later. It will be displayed in the interface (eventually)."
      >
        <b-form-input v-model="displayName" placeholder="" />
      </b-form-group>
      <div>
        <b-button
          @click="createAccount"
          :disabled="!username || !isUsernameValid"
        >
          Create account
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/api";

const validUsernameRE = /[^a-zA-Z0-9._-]/;

export default {
  name: "SetUsername",
  metaInfo: {
    title: "Choose a Username"
  },
  components: {},
  data() {
    return {
      username: "",
      displayName: "",
      usernameExists: false,
      checkingUsername: false
    };
  },
  computed: {
    isUsernameValid() {
      if (!this.checkingUsername && this.username) {
        if (
          this.usernameExists ||
          this.username.length < 3 ||
          this.username.length > 24 ||
          this.username.search(validUsernameRE) !== -1
        ) {
          return false;
        }
        return true;
      }
      return null;
    },
    invalidUsername() {
      if (this.usernameExists) {
        return "That username is already taken";
      }
      if (this.username.search(validUsernameRE) !== -1) {
        return "Usernames can only contain numbers, uppercase and lowercase letters, periods, underscores, and dashes.";
      }
      if (this.username.length < 3) {
        return "Usernames must be at least 3 characters";
      }
      if (this.username.length > 24) {
        return "Usernames are at most 24 characters";
      }
      return "";
    }
  },
  methods: {
    async checkUsername(value) {
      this.checkingUsername = true;
      if (value) {
        try {
          const usernameExists = await api.checkUsername(value);
          this.usernameExists = usernameExists;
        } catch (err) {
          console.error(err);
        }
      } else {
        this.usernameExists = false;
      }
      this.checkingUsername = false;
    },
    async createAccount() {
      try {
        await api.createAccount(this.username, this.displayName);
        // this force a refresh of the page, which should lead
        // to the user being logged in if everything worked correctly
        // https://stackoverflow.com/a/47005895
        this.$router.go();
      } catch (err) {
        this.$root.$bvToast.toast(
          err.response.data || err.response.statusText,
          {
            title: "Error setting username",
            variant: "danger"
          }
        );
      }
    }
  },
  watch: {
    username(newVal) {
      this.checkUsername(newVal);
    }
  }
};
</script>
